import {
  Dialog,
  DialogContent,
  DialogTitle,
  styled,
  IconButton,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import { closeRunDialog } from "./MaintenanceSlice"
import CloseIcon from "@mui/icons-material/Close"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}))
export const RunInfoDialogue = ({ children }: any) => {
  const isModalOpen = useAppSelector(
    (store) => store.maintenance.isRunModelOpen,
  )
  const dispatch = useAppDispatch()
  const handleClose = () => {
    dispatch(closeRunDialog())
  }
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isModalOpen}
      fullWidth={true}
      maxWidth="lg"
    >
      <DialogTitle sx={{ m: 0, p: 1 }} id="customized-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 20,
            zIndex: 100,
            top: 10,
            color: (theme) => theme.palette.grey[500],
            padding: "5px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </BootstrapDialog>
  )
}
